import { DataService } from '../service/data.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CallBackEndService } from '../call-back-end.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-forgot-userid-success',
  templateUrl: './forgot-userid-success.component.html',
  styleUrls: ['./forgot-userid-success.component.css'],
   providers: [DataService]
})
export class ForgotUseridSuccessComponent implements OnInit {
returnUrl: string;
message:string;
  bankName: any;
  contactUsPage: string;
  atmBranch: string;
  constructor(private route: ActivatedRoute,
      private fb: FormBuilder,
      private authenticationservice: DataService,
      public router: Router,webService : CallBackEndService,private http: HttpClient ) {
        this.bankName = webService.getBankName();
        this.getJSON().subscribe(data => {
          this.atmBranch = data.atmBranch;
          this.contactUsPage = data.contactUsPage;
         });    
        
       }
        public getJSON(): Observable<any> {
          return this.http.get('assets/SampleUrl.json'); 
        }
 backHome()
  {
    this.router.navigate([this.returnUrl]); 
  }
  ngOnInit() {

        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/index';
        }
        
  

        goToLink1(){
          //  window.open('http://www.abhinavbank.com/branch.asp','_blank');
          window.open(this.atmBranch,'_blank');
      
          //window.location.href='#/Disclaimer';
        }
        goToLink2(){
          // window.open('https://www.maheshbankpune.in/contact-us.html','_blank');
          // window.open('http://www.abhinavbank.com/contact.asp','_blank'); 
          window.open(this.contactUsPage,'_blank'); 
      
        }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/forgot-userid-success/forgot-userid-success.component.ts